import React, { useState } from 'react'
import useSWRMutation from 'swr/mutation'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { useToast } from '@/components/ui/use-toast'
import { postFetcher } from 'api/swr'

export default function ClearTestApiCacheTab() {
  const { toast } = useToast()
  const [open, setOpen] = useState(false)
  const { trigger, isMutating } = useSWRMutation(
    '/debug-tools/test-api-cache/flush',
    postFetcher,
  )

  const onConfirm = async () => {
    try {
      await trigger({})
      setOpen(false)
      toast({
        title: 'Cleared',
        description:
          'Test environment API cache (Redis db 6) has been fully flushed.',
      })
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : String(err)
      toast({
        variant: 'destructive',
        title: 'Clear failed',
        description: message,
      })
    }
  }

  return (
    <div className="max-w-xl space-y-4 rounded-lg border p-6">
      <p className="text-sm text-muted-foreground leading-relaxed">
        Runs{' '}
        <code className="rounded bg-muted px-1.5 py-0.5 text-xs">FLUSHDB</code>{' '}
        on test Redis (45.79.21.219:9376)
        <span className="font-medium text-foreground"> database 6</span>,
        removing all keys in that database. For staging / frontend debugging
        only.
      </p>
      <Button variant="destructive" onClick={() => setOpen(true)}>
        Clear test environment API cache
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              Clear test environment API cache?
            </DialogTitle>
            <DialogDescription>
              This permanently deletes everything in Redis db 6 on the test
              instance and cannot be undone. Only proceed if you mean to reset
              the test cache and nobody relies on its current contents.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="gap-2 sm:gap-0">
            <Button variant="outline" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button
              variant="destructive"
              onClick={onConfirm}
              disabled={isMutating}
            >
              {isMutating ? 'Clearing…' : 'Confirm clear'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  )
}
